export default "__VITE_ASSET__CdDit5Iw__"